import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/talpool/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner "
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>Talpool Website Development</h1>
            <p style={{ color: "#fff" }}>
              Networking, making connections and being part of the community can
              make all the difference. Being around right people can help bring
              the right opportunities your way.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
